import * as React from 'react';
import { Box, ButtonBase, Tooltip } from '@material-ui/core';
import { VariantType } from 'notistack';
import { CustomIcon } from '../../../custom-forms';
import { useStyles, cx } from '../../../custom-forms';
import { CaseCalculationAlternativePart, CaseCalculationPart } from '../../../interfaces/Case';
import { WorkflowCalculation } from '../../../interfaces/Workflow';
import { useTranslate } from '../../../hooks/useTranslate';
import { useVariantsEnabled } from '../context/CalculationFlagsContext';
import { CalculationActions } from '../types/alternative-calculation.types';
import AlternativeCalculationCells from './AlternativeCalculationCells';

export interface AlternativeCalculationSelectedRowProps {
  part: CaseCalculationPart;
  alternativePart: CaseCalculationAlternativePart;
  workflowCalculation: WorkflowCalculation | null;
  actions: CalculationActions;
  onNotify: (message: string, variant: VariantType) => void;
}

const AlternativeCalculationSelectedRow: React.FC<AlternativeCalculationSelectedRowProps> = ({
  part,
  alternativePart,
  workflowCalculation,
  actions,
  onNotify
}) => {
  const c = useStyles();
  const t = useTranslate();
  const variantsEnabled = useVariantsEnabled();
  const recommended = alternativePart.isSelectedAlternativePart === true;

  return (
    <Box
      ref={(el: HTMLElement | null) => actions.registerRow(alternativePart.id, el)}
      className={cx(c.gridRow, c.selectedRow, c.gutterReserve, recommended && c.resultRowReco)}
    >
      <Box className={cx(c.row, c.justifyEnd)}>
        <Tooltip title={t('ALT_CALC_UNSELECT', 'Scoate din selecție')} placement="right">
          <ButtonBase
            className={cx(c.iconBtn, c.iconBtnSm, c.iconBtnDanger)}
            onClick={() => actions.toggleSelect(part.id, alternativePart)}
          >
            <CustomIcon name="x" />
          </ButtonBase>
        </Tooltip>
      </Box>
      <Box>
        {variantsEnabled && (
          <Tooltip
            title={
              recommended
                ? t('ALT_CALC_RECO_ON', 'Recomandarea service-ului (informativ)')
                : t('ALT_CALC_RECO_OFF', 'Marchează ca recomandată — doar informativ')
            }
            placement="left"
          >
            <ButtonBase
              className={cx(c.iconBtn, c.iconBtnSm, c.iconBtnStar, recommended && c.iconBtnStarOn)}
              disabled={alternativePart.isChild}
              onClick={() =>
                recommended
                  ? actions.clearRecommendation(part.id)
                  : actions.setRecommended(part.id, alternativePart)
              }
            >
              <CustomIcon name={recommended ? 'starFilled' : 'star'} />
            </ButtonBase>
          </Tooltip>
        )}
      </Box>
      <AlternativeCalculationCells
        part={part}
        alternativePart={alternativePart}
        workflowCalculation={workflowCalculation}
        onNotify={onNotify}
      />
    </Box>
  );
};

export default React.memo(AlternativeCalculationSelectedRow);
